import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { environment } from '@root/src/environments/environment';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class LogoComponent {

  logoUrl = environment.logoUrl;
  scale = environment?.logoScale ? parseFloat(environment.logoScale) : 1;
  @Input() width =  120;
  @Input() height =  48;

}
